var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppBody',{attrs:{"title":"Vendas / Programa de Afiliados","subtitle":"Programas de Afiliados","actions":_vm.actions}})
}
var staticRenderFns = []

export { render, staticRenderFns }